import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './MenuOverlay.module.scss';

import { IMenuOverlayProps } from './MenuOverlay.d';
import { joinClassnames } from 'helpers/classNames';
import MenuTitle from '../../Molecules/MenuTitle';
import MenuList from '../../Molecules/MenuList';
import MenuShopButton from '../../Molecules/MenuShopButton';

function MenuOverlay({ isOpened, onClose }: IMenuOverlayProps) {
  return (
    <div
      className={joinClassnames(
        Styles['overlay-wrapper'],
        isOpened
          ? Styles['overlay-wrapper--opened']
          : Styles['overlay-wrapper--closed'],
      )}
    >
      <div className={Styles['wrapper']}>
        <MenuTitle />
        <MenuList onClose={onClose} />
        <MenuShopButton />
      </div>
      <div
        className={joinClassnames(
          Styles['bg-overlay'],
          isOpened
            ? Styles['bg-overlay--opened']
            : Styles['bg-overlay--closed'],
        )}
        onClick={onClose}
      />
    </div>
  );
}

export default MenuOverlay;
